import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ArrowUp from "assets/icons/arrow-up.svg";

interface IFabButton {
  $visible: boolean;
}

const FabButton = styled.button<IFabButton>`
  width: 64px;
  height: 64px;
  border-radius: 40px;
  border: 1px solid var(--gray-light);
  background: var(--gray-lightest);
  position: fixed;
  right: 24px;
  bottom: 24px;
  display: ${(props) => (props.$visible ? "block" : "none")};
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 999;

  &:hover {
    background: var(--gray-light);
    transform: translateY(-2px);
  }

 body.high-contrast &:focus-visible {
  outline: 3px solid yellow;
  outline-offset: 2px;
}

  @media (max-width: 768px) {
    right: 16px;
    bottom: 16px;
    width: 56px;
    height: 56px;
  }
`;

const FabButtonComponent = () => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => setOffset(window.scrollY);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <FabButton
      $visible={offset > 0}
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Voltar ao topo da página"
    >
      <img src={ArrowUp} alt="Voltar ao topo da página" />
    </FabButton>
  );
};

export default FabButtonComponent;
